import React, {useEffect, useState} from "react";
import {getUserInfo, signOut} from "../../services/UserRepository";
import Header from "../../components/navigation/Header";
import {IoLogOutOutline} from "react-icons/io5";
import {useNavigate} from "react-router-dom";


export function UserSettings() {

    const [user, setUser] = useState(null);
    const [deletePass, setDeletePass] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (user === null) {
            getUserInfo().then(user => {
                setUser(user)
            }).catch(err => console.log(err));
        }
    }, [])

    if (user != null) {
        return (
            <>

                <Header/>
                <div className={"container mb-5"}>
                    <div className={" my-4"}>
                        <h5 className={"p-0 m-0"}>{user.firstName} {user.lastName}</h5>
                        <p className={"text-muted p-0 m-0"}>{user.email}</p>
                        <button className={" btn btn-light border mt-2"}
                                data-testid={"logout"}
                                onClick={() => {
                            signOut().then(() => navigate("/"))
                        }}>
                            <IoLogOutOutline size={20} className={"me-2"}/>
                            Logg ut
                        </button>
                    </div>


                    <div className={"mb-4 bg-white"}>
                        <div className={"  d-flex flex-column  justify-content-center"}>
                            <h4>Slett bruker</h4>
                            <p className={"text-muted text-justify"}>Slett brukeren din og fjern all data. Brukeren din vil være
                                tilgjengelig i to uker før den slettes permanent.</p>
                        </div>

                        <div className={""}>

                            <input className={"form-control my-3"} value={deletePass}
                                   placeholder={"Passord"} type={"password"}
                                   onChange={(e) => setDeletePass(e.target.value)}/>
                            <button className={"btn btn-danger text-white"}>Slett bruker</button>

                        </div>

                    </div>
                </div>


            </>
        );

    }

}